

























export default {
    name: 'BasePagination',
    components: {},
    props: {},
    data() {
        return {};
    },
    computed: {
        prevPage() {
            if (this.$store.getters.currentPage === this.$store.getters.firstPage) {
                return this.$store.getters.currentPage;
            }
            return this.$store.getters.currentPage - 1;
        },
        nextPage() {
            if (this.$store.getters.currentPage === this.$store.getters.lastPage) {
                return this.$store.getters.currentPage;
            }
            return this.$store.getters.currentPage + 1;
        },
    },
    methods: {},
};
